var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"bar","height":"430","options":_vm.chartOptions,"series":_vm.series}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }